module.exports = __webpack_public_path__ + "static/ring_of_the_ram-94fa9fd32b19f3663edfcf9011d21d90.jpeg";